import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <path d="M8 25V8h12M8 16h8" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="square" />
    <rect x="22" y="5" width="5" height="5" fill="#0055FF" />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2.5 text-white">
    <LogoMark />
    <span className="font-display text-[15px] font-semibold tracking-tight">
      First Mover <span className="text-zinc-400 font-normal">OS</span>
    </span>
  </Link>
);
